/** @jsx jsx */
import { ContactSection } from '@composite';
import { Layout, StaticSEO, StrapiSectionListContainer } from '@core';
import { useLocale, useTranslate } from '@modules';
import React from 'react';
import { DataPrivacyConfig } from 'src/store/DataPrivacyContext';
import { jsx } from 'theme-ui';

export default () => {
  const ref = React.useRef(null);
  const __ = useTranslate();
  const locale = useLocale();

  return (
    <Layout>
      <DataPrivacyConfig path={`${locale}/data-privacy-quiz`} text={__('navbar.dataprivacy')} />

      <StaticSEO pageId='data-privacy-quiz' />

      <StrapiSectionListContainer pageId='data-privacy-quiz' ref={ref} />

      <ContactSection id='landing.contact' triggerRef={() => ref} />
    </Layout>
  );
};
